import React, { useState } from 'react';
import styled from 'astroturf/react';

import Star from './Star';

const Container = styled.div`
  height: 28px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 16px;
`;

const StarContainer = styled(Star)`
  width: 28px;
  display: flex;
  align-items: center;
  cursor: pointer;
`;

export type StarValue = 1 | 2 | 3 | 4 | 5;

type Props = {
  className?: string;
  stars?: StarValue;
  onChange: (value: StarValue) => void;
};

const Rating: React.FC<Props> = ({ className, stars, onChange }) => {
  const [hoveredStar, setHoveredStar] = useState<number | null>(null);

  return (
    <Container className={className}>
      {new Array(5).fill(null).map((_, index) => (
        <div
          key={index}
          onMouseEnter={() => setHoveredStar(index + 1)}
          onMouseLeave={() => setHoveredStar(null)}
          onClick={(e) => {
            e.stopPropagation();
            onChange((index + 1) as StarValue);
          }}
        >
          <StarContainer
            selected={
              hoveredStar == null && stars != null && stars >= index + 1
            }
            hovered={hoveredStar != null && hoveredStar >= index + 1}
          />
        </div>
      ))}
    </Container>
  );
};

export default Rating;
